import * as Yup from 'yup';

export default Yup.object().shape({
  cfdi: Yup.object()
    .required('SCHEMA_ERRORS.INVOICE_REQUIRED')
    .nullable(),
  amount: Yup.number()
    .typeError('SCHEMA_ERRORS.AMOUNT_REQUIRED')
    .required('SCHEMA_ERRORS.AMOUNT_REQUIRED')
    .positive('SCHEMA_ERRORS.VALUE_GREATER_THAN_ZERO')
    .when('cfdi', (cfdi, schema) =>
      cfdi && cfdi.amountIvaIncluded
        ? schema.max(
            cfdi.amountIvaIncluded,
            'SCHEMA_ERRORS.AMOUNT_TO_PAY_MUST_BE_LESS_THAN_OR_EQUAL_TO_AMOUNT_IVA_INCLUDED'
          )
        : schema
    )
});
